// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Noto Sans JP", sans-serif;
  color: #393939;
  background: #fdfdfd;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Roboto", sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAGA;EACE,uCAAA;EACA,cCWU;EDVV,mBAAA;AAFF;;AAKA;;;;;;EAME,iCAAA;AAFF","sourcesContent":["@import './colors';\n@import './globals';\n\nbody {\n  font-family: 'Noto Sans JP', sans-serif;\n  color: $text-main;\n  background: #fdfdfd;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: 'Roboto', sans-serif;\n}","$black: #011627;\n$white: #FDFFFC;\n$palette-1: #217ed5;\n// $palette-2: #074ba5;\n$palette-2: #52796F;\n$palette-3: #FF9F1C;\n$palette-4:rgba(239, 48, 48, 0.822);\n$palette-5: #748b80;\n// 5fa15a\n// eab271\n// 1d2d44d0\n$nav-outline: #eff;\n$nav-outline-hvr: rgba(#217ed5,.4);\n\n$text-ghost:rgb(0, 0, 0);\n$text-light: #717171;\n$text-main: #393939;\n$text-hard: #212121;\n\n$color-light-grey: #c9c9c9;\n\n$palette-1-v-light: #abeef0;\n\n$palette-1-bg: #e2fcfc;\n$palette-2-bg: #ffe4eb;\n\n$palette-1-light: #1890ff;\n$palette-2-light: #ffe9ee;\n\n$palette-1-dark: #1472ca;\n$palette-2-dark: #ab1236;\n$palette-3-dark: #bb781c;\n$palette-4-dark:rgba(243, 16, 16, 0.87);\n\n$chip-bg: #def5ff;\n$chip-font: #036778;\n\n$palette-1-pastel: #a9fafc;\n\n$nav-back : #96c4a0;\n// 9ecf7d\n// f08585\n// 7dce82\n// rgb(152, 171, 196)"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
